<div class="orderButton" >
  <span
    class="product-detail-order-link uppercase"
    [ngClass]="{'product-detail-play-trailer-link-active': activeClass }" [translate]="'eos-tv-shop-ii.text.playtrailer'">
  </span>
</div>
